import { COLORS } from '@stitch-fix/mode-react';
import { formatMoney } from '@stitch-fix/format/formatMoney';
import type { GetMiniPdpProductQuery } from './getMiniPdpProduct';
import type { MiniPdpProduct } from './MiniPdpModal.types';

export const buildMiniPdpProduct = (
  product: GetMiniPdpProductQuery['shopProductBySkuId'],
  skuId: string,
): MiniPdpProduct | undefined => {
  const variant = product?.variantBySkuId;

  // A missing selected SKU must not silently display the default variant.
  if (!product || !variant || variant.sku !== skuId) return undefined;

  return {
    sku: variant.sku,
    name: product.name,
    brand: product.brand.name,
    price: formatMoney(variant.price.value, {
      inCents: true,
    }),
    colorName: variant.color.name,
    size: variant.size.name,
    inseam: variant.inseam?.name,
    productDetails: product.description || undefined,
    detailGroups: variant.detailGroups,
    media: [...variant.media]
      .sort((left, right) => left.position - right.position)
      .map(image => ({
        src: image.originalSrc.replace(
          '/upload/',
          `/upload/f_auto,q_auto,w_800/${
            image.contentGroup === 'figure_image'
              ? ''
              : `e_replace_color:${COLORS['gray-95'].replace(
                  '#',
                  '',
                )}:300:ffffff/`
          }`,
        ),
        alt: image.altText,
      })),
    paymentOptions: {
      installmentPaymentsLabel: variant.installmentPayments.label,
      buyNowPayLaterHelpContent: variant.buyNowPayLaterHelpContent,
      priceMarkdown: variant.priceMarkdown,
      priceStickerLabel: variant.priceStickerLabel,
      priceType: variant.priceType,
    },
  };
};
